import React, { useState } from 'react';
import axios from 'axios';

// Import image assets directly from src/assets/
import logoImg from '../assets/logo.png';
import bgImg from '../assets/docblur.jpg';

const API_URL = "https://holisticphysiotherapy.in/holistic_bill/api.php"; 

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await axios.post(`${API_URL}?action=login`, {
        username,
        password
      });

      if (res.data.status === 'success') {
        onLoginSuccess(res.data.user);
      } else {
        setError(res.data.message || 'Invalid username or password.');
      }
    } catch (err) {
      setError('Server error. Please check XAMPP Apache & MySQL.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="container-fluid min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 32, 67, 0.60), rgba(15, 32, 67, 0.60)), url(${bgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="col-12 col-sm-8 col-md-5 col-lg-4 px-3">
        {/* Frosted Glass Card */}
        <div 
          className="card border-0 p-4 shadow-lg"
          style={{
            background: 'rgba(255, 255, 255, 0.92)',
            backdropFilter: 'blur(10px)',
            borderRadius: '12px'
          }}
        >
          {/* Logo & Header */}
          <div className="text-center mb-4">
            <img 
              src={logoImg} 
              alt="Holisticphysiotherapy Logo" 
              style={{ height: '75px', width: 'auto', objectFit: 'contain' }}
              className="mb-2"
            />
            <h4 className="fw-bold mb-1"  style={{color:"#007C9D"}}>Holistic Physiotherapy</h4>
            <p className="text-muted small mb-0">Billing & Patient Management System</p>
          </div>

          {/* Error Alert */}
          {error && (
            <div className="alert alert-danger py-2 small text-center" role="alert">
              {error}
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-bold small text-dark">Username</label>
              <input
                type="text"
                className="form-control form-control-lg fs-6"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-bold small text-dark">Password</label>
              <input
                type="password"
                className="form-control form-control-lg fs-6"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-lg w-100 fw-bold fs-6 shadow-sm"
              style={{backgroundColor:"#007C9D", color:"white"}}
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}